function activateMegaMenuTrigger(trigger) {
  if (!trigger) return;

  const nav = trigger.closest('mega-menu-nav');
  const group = trigger.dataset.megaGroup;
  const targetId = trigger.dataset.megaTarget;
  if (!nav || !group || !targetId) return;
  if (trigger.classList.contains('is-active')) return;

  nav.querySelectorAll(`[data-mega-group="${group}"]`).forEach((item) => {
    const isActive = item === trigger;
    item.classList.remove('is-active', 'mega-menu__link--active');
    if (isActive) item.classList.add('is-active');
    if (item.hasAttribute('aria-expanded')) {
      item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    }
  });

  nav.querySelectorAll(`[data-mega-panel-group="${group}"]`).forEach((panel) => {
    panel.toggleAttribute('hidden', panel.dataset.megaPanel !== targetId);
  });

  if (group === 'department') {
    const departmentPanel = nav.querySelector(`[data-mega-panel="${targetId}"]`);
    const defaultCategory =
      departmentPanel?.querySelector('[data-mega-group="category"].is-active') ||
      departmentPanel?.querySelector('[data-mega-default]') ||
      departmentPanel?.querySelector('[data-mega-group="category"][data-mega-target]');
    activateMegaMenuTrigger(defaultCategory);
  }
}

function onMegaMenuPointer(event) {
  const trigger = event.target.closest('mega-menu-nav [data-mega-target]');
  if (!trigger) return;
  activateMegaMenuTrigger(trigger);
}

function onMegaMenuClick(event) {
  if (!window.matchMedia('(pointer: coarse)').matches) return;
  const trigger = event.target.closest('mega-menu-nav [data-mega-target]');
  if (!trigger || trigger.classList.contains('is-active')) return;
  event.preventDefault();
  activateMegaMenuTrigger(trigger);
}

if (window.__megaMenuNavAbort) window.__megaMenuNavAbort.abort();
window.__megaMenuNavAbort = new AbortController();

document.addEventListener('mouseover', onMegaMenuPointer, {
  capture: true,
  signal: window.__megaMenuNavAbort.signal,
});
document.addEventListener('focusin', onMegaMenuPointer, {
  capture: true,
  signal: window.__megaMenuNavAbort.signal,
});
document.addEventListener('click', onMegaMenuClick, {
  capture: true,
  signal: window.__megaMenuNavAbort.signal,
});
